<!-- Two navigations, not one template stretched over both: the left rail below is
     desktop-only, and under 992px the section list lives in the bottom sheet at the
     end of this file (Figma "account navigation - mobile", 15002:262811). -->
<div class="account-section">
  <div class="container account-container">

    <nav class="account-crumbs" aria-label="Breadcrumb">
      <a routerLink="/">Home</a>
      <img class="crumb-sep" src="/images/svg/account/chevron-right-grey.svg" alt="" aria-hidden="true" />
      <ng-container *ngIf="isOverviewPage(); else sectionCrumb">
        <span class="crumb-current">Account</span>
      </ng-container>
      <ng-template #sectionCrumb>
        <a routerLink="/account">Account</a>
        <img class="crumb-sep" src="/images/svg/account/chevron-right-grey.svg" alt="" aria-hidden="true" />
        <!-- A detail page pushes its section back into a link and takes the tail. -->
        <ng-container *ngIf="detailCrumbLabel() as detail; else sectionTail">
          <a [routerLink]="sectionLink()">{{ currentSectionLabel() }}</a>
          <img class="crumb-sep" src="/images/svg/account/chevron-right-grey.svg" alt="" aria-hidden="true" />
          <span class="crumb-current">{{ detail }}</span>
        </ng-container>
        <ng-template #sectionTail>
          <span class="crumb-current">{{ currentSectionLabel() }}</span>
        </ng-template>
      </ng-template>
    </nav>

    <!-- Mobile: the current section reads as a field, and tapping it raises the sheet. -->
    <button type="button" class="account-mobile-bar" (click)="openMobileNav()" aria-haspopup="dialog"
      [attr.aria-expanded]="mobileNavOpen">
      {{ currentSectionLabel() }}
    </button>

    <div class="account-layout" [class.is-collapsed]="collapsed">
      <aside class="account-sidebar">
        <ng-container *ngTemplateOutlet="railTpl"></ng-container>
      </aside>

      <div class="account-content" [class.account-content--card]="!isPlainPage()">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!-- Mobile drawer -->
<div class="account-sheet-backdrop" [class.open]="mobileNavOpen" (click)="closeMobileNav()"></div>
<div class="account-sheet" [class.open]="mobileNavOpen" role="dialog" aria-modal="true" aria-label="Account menu">
  <span class="sheet-grip" aria-hidden="true"></span>

  <div class="sheet-inner">
    <div class="sheet-head">
      <button type="button" class="sheet-close" aria-label="Close account menu" (click)="closeMobileNav()">
        <img src="/images/svg/account/close.svg" alt="" />
      </button>
    </div>

    <div class="sheet-body">
      <ng-container *ngFor="let group of navGroups">
        <div class="sheet-group" *ngIf="hasVisibleItems(group)">
          <p class="sheet-group-label">{{ group.label }}</p>
          <div class="sheet-items">
            <ng-container *ngFor="let item of group.items">
              <a *ngIf="item.isShow" class="sheet-item" [class.active]="isActive(item)"
                [routerLink]="item.external ? item.path : ['/account', item.path]" (click)="closeMobileNav()">
                <img class="sheet-item-icon"
                  [src]="'/images/svg/account/' + item.icon + (isActive(item) ? '-active' : '') + '.svg'" alt="" />
                <span class="sheet-item-label">{{ item.label }}</span>
              </a>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="sheet-items sheet-items--footer">
        <a class="sheet-item sheet-logout" (click)="logout()">
          <img class="sheet-item-icon" src="/images/svg/account/logout.svg" alt="" />
          <span class="sheet-item-label">Log Out</span>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #railTpl>
  <div class="rail">
    <!-- Collapse toggle -->
    <div class="rail-top">
      <button type="button" class="rail-toggle" (click)="toggleCollapsed()"
        [attr.aria-label]="collapsed ? 'Expand account menu' : 'Collapse account menu'"
        [attr.aria-expanded]="!collapsed">
        <ng-container *ngTemplateOutlet="toggleGlyphTpl"></ng-container>
      </button>
    </div>

    <div class="rail-body">
      <div class="rail-main">
        <div class="rail-identity-wrap">
          <a class="rail-identity" routerLink="/account/profile">
            <img class="rail-avatar" [src]="avatarSrc" alt="" (error)="onAvatarError()" />
            <span class="rail-identity-details">
              <span class="rail-identity-details-inner">
                <span class="rail-identity-text">
                  <span class="rail-name">{{ displayName }}</span>
                  <span class="rail-meta">
                    <span class="rail-company" *ngIf="user?.customer?.customerName">{{ user.customer.customerName
                      }}</span>
                    <span class="rail-email" *ngIf="user?.email">{{ user.email }}</span>
                  </span>
                </span>
                <span class="rail-view-profile">
                  View Profile
                  <img src="/images/svg/account/chevron-right-blue.svg" alt="" aria-hidden="true" />
                </span>
              </span>
            </span>
          </a>
          <div class="rail-divider"></div>
        </div>

        <div class="rail-groups">
          <ng-container *ngFor="let group of navGroups">
            <div class="rail-group" *ngIf="hasVisibleItems(group)">
              <p class="rail-group-label">{{ group.label }}</p>
              <div class="rail-items">
                <ng-container *ngFor="let item of group.items">
                  <a *ngIf="item.isShow" class="rail-item" [class.active]="isActive(item)"
                    [routerLink]="item.external ? item.path : ['/account', item.path]"
                    [attr.title]="collapsed ? item.label : null">
                    <img class="rail-item-icon"
                      [src]="'/images/svg/account/' + item.icon + (isActive(item) ? '-active' : '') + '.svg'" alt="" />
                    <span class="rail-item-label">{{ item.label }}</span>
                  </a>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="rail-footer">
        <div class="rail-divider"></div>
        <a class="rail-item rail-logout" (click)="logout()" [attr.title]="collapsed ? 'Log Out' : null">
          <img class="rail-item-icon" src="/images/svg/account/logout.svg" alt="" />
          <span class="rail-item-label">Log Out</span>
        </a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #toggleGlyphTpl>
  <span class="rail-toggle-icon" aria-hidden="true">
    <span class="rail-toggle-glyph rail-toggle-glyph--collapse"></span>
    <span class="rail-toggle-glyph rail-toggle-glyph--expand"></span>
  </span>
</ng-template>
